import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getClientTypes = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return await apiClient.get('/client_types?' + params.toString()); 
};

const getClientTypeById = async (id: number) => {
  return await apiClient.get(`/client_types/${id}`); 
};

const createClientType = async (clientTypeData: any) => {
  return await apiClient.post('/client_types', clientTypeData);
};

const updateClientType = async (id: number, clientTypeData: any) => {
  return await apiClient.patch(`/client_types/${id}`, clientTypeData); 
};

const deleteClientType = async (id: number) => {
  return await apiClient.delete(`/client_types/${id}`);
};

export default {
    getClientTypes,
    getClientTypeById,
    createClientType,
    updateClientType,
    deleteClientType
};
